import { getNextPositionFromEdges } from './get-next-position.checks';

export const getNextPosition = (allCollisions, currentPosition) => {
  const aggregateCollisions = allCollisions.reduce((acc, collisions) => ({ ...acc, ...collisions }), {});

  // If this is something like 'left-bottom' vs 'bottom-left', flip the variables
  const flipItFlipItGood = ['left', 'right'].indexOf(currentPosition) === 0;
  const nextPosition = getNextPositionFromEdges(currentPosition, aggregateCollisions, flipItFlipItGood);

  // If this is something like 'left-bottom' vs 'bottom-left', flip the array so the nextPosition outputs properly
  if (flipItFlipItGood) {
    nextPosition.reverse();
  }

  return nextPosition.join('-');
};
